/**
 * API 列表
 */
const config = {
  loginPage: '/login',
  appId: 'parentNet', //配置APPID

 // server: 'https://test-api-parentnet.cctechhk.com',
 //server: 'https://api.parentnet.hk',

 //server: 'http://localhost:8080',
    server: 'https://api-parentnet.hkep.com', // 教图自己的生产域名


}

const apiList = {
	 	checkExists: "user/api/old/checkLogin", //檢查是否註冊過
		sendCode: "user/api/getVerificationCode", //發送驗證碼
		regist: "user/api/register", //注册
		oldMsg: "user/api/oldMsg", //
}

export default {
  config,
  apiList
}
